import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api.service';
import { List } from 'src/app/core/models/list';
import { Filters } from 'src/app/core/services/list/models/Filters';
import { apiRoutes } from 'src/environments/api-routes';
import { GenericObject } from '../../utils/models/generic-object';
import { Notification } from '../models/notification.model';
import { Replenishment } from '../models/replenishment.model';

@Injectable({
  providedIn: 'root',
})
export class ReplenishmentApiService {
  private apiRoutes = apiRoutes;

  constructor(private apiService: ApiService, private http: HttpClient) {}

  public takeReplenishment(replenishmentId: number, quantity: number): Observable<any> {
    return this.http.post<void>(
      this.apiService.getUrl(
        this.apiRoutes.inventory.replenishment.action.take.replace('{replenishmentId}', replenishmentId.toString()),
      ),
      {
        quantity,
      },
    );
  }

  replenish(replenishmentId: number, quantity: number): Observable<any> {
    return this.http.post<void>(
      this.apiService.getUrl(
        this.apiRoutes.inventory.replenishment.action.replenish.replace(
          '{replenishmentId}',
          replenishmentId.toString(),
        ),
      ),
      {
        quantity,
      },
    );
  }

  public getUnassignedReplenishment(filters: Filters): Observable<List<Replenishment>> {
    return this.http.get<List<Replenishment>>(
      this.apiService.getUrl(this.apiRoutes.inventory.replenishment.status.unassigned, filters),
    );
  }

  getRelatedReplenishment(filters: Filters, genericFilters): Observable<List<Replenishment>> {
    return this.http.get<List<Replenishment>>(
      this.apiService.getUrl(this.apiRoutes.inventory.replenishment.status.unassigned, filters, genericFilters),
    );
  }

  getAssignedReplenishment(filters: Filters): Observable<List<Replenishment>> {
    return this.http.get<List<Replenishment>>(
      this.apiService.getUrl(this.apiRoutes.inventory.replenishment.status.assigned, filters),
    );
  }

  getNewReplenishment(filters: Filters): Observable<List<Replenishment>> {
    return this.http.get<List<Replenishment>>(
      this.apiService.getUrl(this.apiRoutes.inventory.replenishment.status.new, filters),
    );
  }

  getDoneReplenishment(filters: Filters): Observable<List<Replenishment>> {
    return this.http.get<List<Replenishment>>(
      this.apiService.getUrl(this.apiRoutes.inventory.replenishment.status.done, filters),
    );
  }

  public postReserveReplenishment(replenishments: number[] | number): Observable<any> {
    return this.http.post(
      this.apiService.getUrl(this.apiRoutes.inventory.replenishment.status.reserved, null, { replenishments }),
      {},
    );
  }

  getReservedReplenishment(filters: GenericObject<any>): Observable<List<Replenishment>> {
    return this.http.get<List<Replenishment>>(
      this.apiService.getUrl(this.apiRoutes.inventory.replenishment.status.reserved, null, filters),
    );
  }

  deleteReservedReplanishment(replenishmentId: number): Observable<List<Notification>> {
    return this.http.delete<List<Notification>>(
      this.apiService.getUrl(this.apiRoutes.inventory.replenishment.status.reserved, null, {
        replenishments: replenishmentId,
      }),
    );
  }

  public putProduct(id: number): Observable<void> {
    return this.http.put<void>(this.apiService.getUrl(this.apiRoutes.inventory.replenishment.put), { id });
  }
}
